import { render } from "./About.vue?vue&type=template&id=eb301fba"
const script = {}
script.render = render

export default script